import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyFieldProps } from '@ngx-formly/bootstrap/form-field';
import { FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SelectModule } from 'primeng/select';

interface SelectFieldProps extends FormlyFieldProps {
  optionValue: string;
  optionLabel: string;
  canFilter: boolean;
  canClear: boolean;
  placeholderText: string;
  selectOptions: {
    label: string;
    value: number | string | boolean;
  }[];
}

@Component({
  selector: 'app-select-field',
  imports: [
    ReactiveFormsModule,
    FormlyModule,
    SelectModule,
    TranslatePipe,
    NgIf,
  ],
  templateUrl: './select-field.component.html',
  styleUrl: './select-field.component.scss',
})
export class SelectFieldComponent extends FieldType<
  FieldTypeConfig<SelectFieldProps>
> {
  override defaultOptions = {
    props: {
      optionLabel: 'label',
      optionValue: 'value',
      placeholderText: 'COMMON.CHOOSE',
      canFilter: false,
      canClear: false,
      selectOptions: [],
    },
  };
}
